import { __assign, __makeTemplateObject, __rest } from 'tslib';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { backgroundColor, boxShadow, space, layout, borders, positioning, overflow } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var defaultStyles = {
  borderRadius: "5px",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};
var cardVariants = {
  default: __assign(__assign({}, defaultStyles), {
    boxShadow: "0 5px 15px 0 rgba(0, 0, 0, 0.15)"
  }),
  soft: __assign(__assign({}, defaultStyles), {
    boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.10)"
  }),
  hard: __assign(__assign({}, defaultStyles), {
    boxShadow: "0 5px 25px 0 rgba(0, 0, 0, 0.2)"
  })
};
var StyledCard = /*#__PURE__*/styled("div").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Card__StyledCard",
  componentId: "sc-1h765zk-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, boxShadow, flexboxes, space, layout, borders, positioning, overflow);
var Card = forwardRef(function (_a, ref) {
  var variant = _a.variant,
    children = _a.children,
    rest = __rest(_a, ["variant", "children"]);
  var styles = cardVariants[variant];
  return React__default.createElement(StyledCard, __assign({
    ref: ref
  }, styles, rest), children);
});
Card.defaultProps = {
  variant: "default"
};
Card.displayName = "Card";
var templateObject_1;

export { Card, StyledCard, cardVariants };
//# sourceMappingURL=Card.js.map
